<template>
  <vgloballayout :loading="loading" :error="error">
    <div slot="body">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="12"
          ><h1>Лицевой счет {{ dataAccount.information.number }}</h1></el-col
        >
      </el-row>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="margin-right: 1em;">Информация о лицевом счете</span>

          <span
            slot="reference"
            v-if="dataAccount.recipient.isActive"
            class="payment-active"
            style="color: #67c23a"
          >
            <i class="el-icon-check m-r-5"></i>
            Оплата подключена
          </span>

          <el-popover
            v-else
            placement="top-start"
            title="Внимание"
            trigger="hover"
            content="Обратитесь в тех. поддержку"
          >
            <span
              slot="reference"
              class="payment-active"
              style="color: #f56c6c"
            >
              <i class="el-icon-warning m-r-5"></i>
              Оплата отключена
            </span>
          </el-popover>
        </div>
        <div class="account-info__str">
          <div class="account-info__str--bold">ID:</div>
          <div class="account-info__str--normal">
            {{ dataAccount.information.id }}
          </div>
        </div>
        <div class="account-info__str">
          <div class="account-info__str--bold">Адрес:</div>
          <div class="account-info__str--normal">
            {{ dataAccount.information.address }}
          </div>
        </div>
        <div class="account-info__str">
          <div class="account-info__str--bold">ЛС:</div>
          <div class="account-info__str--normal">
            {{ dataAccount.information.number }}
          </div>
        </div>
        <div class="account-info__str">
          <div class="account-info__str--bold">Тип:</div>
          <div class="account-info__str--normal">
            {{ dataAccount.information.balanceType }}
          </div>
        </div>
        <div class="account-info__str">
          <div class="account-info__str--bold">Бумажные квитанции:</div>
          <div class="account-info__str--normal">
            {{
              dataAccount.information.invoiceDisabled ? "Отписан" : "Подписан"
            }}
          </div>
        </div>
        <div class="account-info__str">
          <div class="account-info__str--bold">Баланс:</div>
          <div :class="`account-info__str--normal account-info__str--${dataAccount.information.debt > 0 && 'green'} account-info__str--${dataAccount.information.debt < 0 && 'red'}`" >
            {{ dataAccount.information.debt }}
          </div>
        </div>
      </el-card>

      <el-card class="box-card m-t-30">
        <div slot="header" class="clearfix">
          <span>Начисления</span>
        </div>

        <el-table
          v-loading="loading"
          empty-text="Записи отсутствуют"
          style="width: 100%"
          height="450"
          :data="dataAccount.accurals"
        >
          <el-table-column label="Период" prop="periodName"> </el-table-column>

          <el-table-column label="Начал. остаток" prop="inBalance">
          </el-table-column>

          <el-table-column label="Начислено" prop="sum"> </el-table-column>

          <el-table-column label="Пени" prop="fine"> </el-table-column>

          <el-table-column label="Поступило" prop="payed"> </el-table-column>

          <el-table-column width="110">
            <template slot-scope="scope">
              <el-row
                v-if="scope.row.invoiceExists"
                type="flex"
                class="row-bg"
                justify="space-between"
              >
                <el-link
                  target="_blank"
                  type="primary"
                  :href="
                    `${url}/Admin/GetInvoice/${scope.row.accountId}?period=${scope.row.periodId}`
                  "
                  >Квитанция</el-link
                >
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <el-card class="box-card m-t-30">
        <div slot="header" class="clearfix">
          <span>Счетчики</span>
        </div>

        <el-table
          v-loading="loading"
          empty-text="Записи отсутствуют"
          style="width: 100%"
          :data="dataAccount.counters"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <p>Марка: {{ props.row.mark }}</p>
              <p>Модель: {{ props.row.model }}</p>
              <p>Серийный номер: {{ props.row.serialNumber }}</p>
              <p>
                Дата следующей проверки:
                {{ dateReturnFormat(props.row.nextVerificationDate) }}
              </p>
            </template>
          </el-table-column>

          <el-table-column label="Счетчик" prop="serviceName">
          </el-table-column>

          <el-table-column label="Предыдущие показания" prop="value">
          </el-table-column>

          <el-table-column label="Текущие показания" prop="userValue">
          </el-table-column>
        </el-table>
      </el-card>

      <el-card class="box-card m-t-30">
        <div slot="header" class="clearfix">
          <span>Платежи</span>
        </div>

        <div class="block m-b-20">
          <span class="m-r-20">
            <span class="demonstration p-r-10">c</span>
            <el-date-picker
              v-model="paymentsForm.DateBegin"
              type="date"
              size="small"
              v-mask="'##.##.####'"
              format="dd.MM.yyyy"
              placeholder="Выберите дату"
            >
            </el-date-picker>
          </span>

          <span class="m-r-20">
            <span class="demonstration p-r-10">по</span>
            <el-date-picker
              v-model="paymentsForm.DateEnd"
              type="date"
              size="small"
              v-mask="'##.##.####'"
              format="dd.MM.yyyy"
              placeholder="Выберите дату"
            >
            </el-date-picker>
          </span>

          <el-button size="mini" type="primary" @click="paymentsGet()">
            Поиск
          </el-button>
        </div>

        <el-table
          v-loading="loading"
          empty-text="Записи отсутствуют"
          style="width: 100%"
          :data="payments"
        >
          <el-table-column label="Дата платежа" prop="paymentDate">
            <template slot-scope="scope">
              {{ dateReturnFormat(scope.row.paymentDate) }}
            </template>
          </el-table-column>

          <el-table-column label="Сумма" prop="sum"> </el-table-column>

          <el-table-column label="Статус" prop="state"> </el-table-column>

          <el-table-column label="Банк" prop="bankName"> </el-table-column>

          <el-table-column label="РС" width="210" prop="rs"> </el-table-column>

          <el-table-column label="Чек" width="50" prop="state">
            <template slot-scope="scope">
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-link
                  target="_blank"
                  type="primary"
                  :href="`${url}/Admin/GetCheck/${scope.row.paymentId}`"
                  >Чек</el-link
                >
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
  </vgloballayout>
</template>

<script>
import { BASE_URL, BASE_DOC_URL } from "@/plugins/url-env";
import { dateReturnFormat } from "@/plugins/methods";
import {changeDateISOValue} from '@/plugins/dateParser'

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      error: false,
      value1: false,
      dataAccount: {
        information: {},
        recipient: {},
        accurals: []
      },
      payments: [],
      url: BASE_URL,
      paymentsForm: {
        DateBegin: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        DateEnd: new Date()
      }
    };
  },

  mounted() {
    this.onLoad();
  },

  methods: {
    async paymentsGet() {
      try {
        const dateBeginRightValue = changeDateISOValue(this.paymentsForm.DateBegin, { newHours: '00', newMinutes: '00', newSeconds: '00'})
        const dateEndRightValue = changeDateISOValue(this.paymentsForm.DateEnd, { newHours: 23, newMinutes: 59, newSeconds: 59})

        let formData = {
          AccountId: this.$route.params.id,
          DateBegin: dateBeginRightValue,
          DateEnd: dateEndRightValue
        };
        
        this.payments = [];
        this.payments = await this.$store.dispatch("getPayments", formData);
      } catch (e) {
        this.$ErrorsMod(e);
      }
    },

    dateReturnFormat(date) {
      return dateReturnFormat(date);
    },
    async onLoad() {
      this.loading = true;
      this.error = false;

      try {
        this.dataAccount = await this.$store.dispatch("getInformation", {
          accountId: this.$route.params.id
        });
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      }

      this.loading = false;
    }
  },
  components: {}
};
</script>

<style lang="sass">
.account-info
    &__str
        color: #303133
        display: flex
        justify-content: flex-start
        margin: 10px 0
        font-size: 14px
        &--bold
            font-weight: bold
            margin-right: 10px
            &--normal
                color: #606266
        &--green
            color: #7db341
        &--red
            color: red
            

    .payment-active
        float: right
        padding: 3px 0
        font-size: 15px
</style>

<style lang="sass" scoped>
.el-table__row:nth-child(odd)
    background-color: #F7F7F7
</style>
